import { render, staticRenderFns } from "./DayplannerEditor.vue?vue&type=template&id=2cbb7d95&"
import script from "./DayplannerEditor.vue?vue&type=script&lang=js&"
export * from "./DayplannerEditor.vue?vue&type=script&lang=js&"
import style0 from "./DayplannerEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports